"use client";

import { Link } from "react-router-dom";
import { useState } from "react";
import { useBranches } from "@/hooks/api/useBranches";
import { useBranchesEnabled } from "@/hooks/api/useBranchesEnabled";
import { useGrns } from "@/hooks/api/useGrns";
import { Badge } from "@/components/ui/badge";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Card } from "@/components/ui/card";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export default function GrnListPage() {
  const { data: branches } = useBranches();
  const { branchesEnabled } = useBranchesEnabled();
  const [branchId, setBranchId] = useState<number | undefined>();
  const bid = branchId ?? branches?.[0]?.id;
  const showBranchPicker = branchesEnabled && (branches?.length ?? 0) > 1;
  const { data: grns = [], isLoading } = useGrns({ branch_id: bid });

  return (
    <div className="space-y-4 p-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h1 className="text-xl font-semibold">GRNs</h1>
        <div className="flex gap-2">
          {showBranchPicker ? (
            <Select value={bid ? String(bid) : ""} onValueChange={(v) => setBranchId(Number(v))}>
              <SelectTrigger className="w-[200px]">
                <SelectValue placeholder="Branch" />
              </SelectTrigger>
              <SelectContent>
                {(branches ?? []).map((b) => (
                  <SelectItem key={b.id} value={String(b.id)}>
                    {b.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          ) : null}
          <Link
            to="/purchase/orders"
            className={cn(buttonVariants({ variant: "outline" }), "inline-flex h-9 items-center px-3")}
          >
            POs
          </Link>
        </div>
      </div>
      {isLoading && <p className="text-sm text-muted-foreground">Loading…</p>}
      <div className="grid gap-2">
        {grns.map((g) => (
          <Card key={g.id} className="flex flex-wrap items-center justify-between gap-2 p-3">
            <div>
              <Link to={`/purchase/grn/${g.id}`} className="font-mono font-medium hover:underline">
                {g.grn_no}
              </Link>
              <p className="text-xs text-muted-foreground">
                {g.grn_date} · PO #{g.po_id ?? "—"} · ₹{Number(g.total_amount).toLocaleString("en-IN")}
              </p>
            </div>
            <Badge variant={g.status === "completed" ? "default" : "secondary"}>{g.status}</Badge>
          </Card>
        ))}
      </div>
    </div>
  );
}
